import axios from "axios";
import Config from "../../../config";

const v2_actionListGroups = (clienteId, canalId) => {
    const baseUrl = Config.dev ? Config.url_dev : Config.urlBackend;
    const qs = canalId ? `?canalId=${canalId}` : '';
    return axios({
        method: "get",
        url: `${baseUrl}/api/v2/chats/${clienteId}/groups${qs}`,
        timeout: 30000
    });
};

export default v2_actionListGroups;
